import { ACTIONS } from '../config/constants';

export function updateAuth(accessToken, refreshToken, expiresAt) {
  return dispatch =>
    dispatch({
      type: ACTIONS.TYPES.AUTH.UPDATE_AUTH,
      auth: { accessToken, refreshToken, expiresAt }
    });
}



// WEBPACK FOOTER //
// ./src/actions/auth.js